import { useState, useEffect } from "react";

import ButtonIconH from "../../components/ButtonIconH";
import InputData from "../../components/InputData";
import InputTextArea from "../../components/InputTextArea";
import TooltipBox from "../../components/Tooltip";

import { post } from "../../js/post";
import { userData, selectedOptic } from "../../js/utils";

import { SMS_MAX_LENGTH } from "../js/constants";

import "../css/SendSMSPopup.css";

export default ({
  show,
  onClose,
  idPaciente,
  nombrePaciente,
  telefonoPaciente,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [mensaje, setMensaje] = useState("");
  const [testField, setTestField] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [enviandoPrueba, setEnviandoPrueba] = useState(false);

  useEffect(() => {
    if (show) {
      setMensaje("");
      setTestField("");
      setEnviando(false);
      setEnviandoPrueba(false);
    }
  }, [show]);

  const enviarSMS = async () => {
    if (mensaje.trim() === "") {
      createPopupQuestion(
        "Debe escribir un mensaje para poder enviarlo.",
        removePopupQuestion,
        null,
        "Cerrar",
      );
      return;
    }

    setEnviando(true);
    const response = await post("EnviarSMS.php", {
      token: userData.token,
      msg: mensaje,
      idPaciente,
      idOptica: selectedOptic.id,
    });
    setEnviando(false);

    if (response.error === "") {
      createPopupQuestion(
        "Mensaje enviado correctamente.",
        () => {
          removePopupQuestion();
          onClose();
        },
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(response.error, removePopupQuestion, null, "Cerrar");
    }
  };

  const enviarPrueba = async () => {
    if (testField === "") return;

    setEnviandoPrueba(true);
    const response = await post("EnviarSMSPrueba.php", {
      token: userData.token,
      msg: mensaje,
      idPaciente,
      idOptica: selectedOptic.id,
      movil: testField,
    });
    setEnviandoPrueba(false);

    if (response.error === "") {
      createPopupQuestion(
        "Mensaje enviado correctamente.",
        removePopupQuestion,
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(response.error, removePopupQuestion, null, "Cerrar");
    }
  };

  const confirmarCierre = () => {
    createPopupQuestion(
      "¿Deseas cancelar el envío de mensaje SMS?",
      () => {
        removePopupQuestion();
        onClose();
      },
      removePopupQuestion,
      "Sí",
      "No",
    );
  };

  const numMensajes = Math.max(1, Math.ceil(mensaje.length / SMS_MAX_LENGTH));

  return (
    show && (
      <div className="popup-container popup-normal popup-send-sms">
        <div className="popup-message">
          <div className="popup-header">
            <div className="popup-title">Enviar SMS</div>
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt=""
              className="popup-close"
              onClick={confirmarCierre}
            />
          </div>
          <div className="popup-body">
            <div className="popup-row">
              <div className="label">Paciente</div>
              <span className="send-sms-value">{nombrePaciente}</span>
            </div>
            <div className="popup-row">
              <div className="label">Teléfono</div>
              <span className="send-sms-value">{telefonoPaciente}</span>
            </div>
            <div className="popup-row popup-row-top">
              <div className="label send-sms-message-label">
                Mensaje
                <img
                  src="/images/info-blue.svg"
                  loading="lazy"
                  alt="Icon"
                  className="cell-icon"
                  data-tooltip-id="send-sms-info"
                />
              </div>
              <TooltipBox
                id="send-sms-info"
                content={
                  <div className="opt-table-tooltip grid-5">
                    <div className="cell combined-cells-5 cell-start-content">
                      Variables disponibles:
                    </div>
                    <div className="cell combined-cells-5 cell-start-content">
                      <strong>nombre0cliente0largo</strong>: Nombre del
                      paciente.
                    </div>
                    <div className="cell combined-cells-5 cell-start-content">
                      <strong>eda</strong>: Edad del paciente.
                    </div>
                    <div className="cell combined-cells-5 cell-start-content">
                      <strong>dd0mm0yyyy</strong>: Fecha de la próxima cita.
                    </div>
                    <div className="cell combined-cells-5 cell-start-content">
                      <strong>hh0mm</strong>: Hora de la última cita.
                    </div>
                    <div className="cell combined-cells-5 cell-start-content">
                      <strong>p0ppp</strong>: Puntos disponibles.
                    </div>
                    <div className="cell combined-cells-5 cell-start-content">
                      <strong>vpu0de</strong>: Valor de los puntos disponibles.
                    </div>
                    <div className="cell combined-cells-5 cell-start-content">
                      <strong>p0pvp0to</strong>: Precio total de la última
                      compra.
                    </div>
                    <div className="cell combined-cells-5 cell-start-content">
                      <strong>p0pvp0pa</strong>: Abono total de la última
                      compra.
                    </div>
                    <div className="cell combined-cells-5 cell-start-content">
                      <strong>p0pvp0pe</strong>: Pendiente de abono de la última
                      compra.
                    </div>
                    <div className="cell combined-cells-5 cell-start-content">
                      <strong>BAJA00url0de0baja0segura</strong>: URL de baja de
                      notificaciones.
                    </div>
                  </div>
                }
              />
              <InputTextArea
                id="send-sms-mensaje"
                upperCase={false}
                rows={7}
                type="type-full"
                size={0}
                extra="send-sms-textarea"
                input={mensaje}
                onChange={setMensaje}
              />
            </div>
            <div className="popup-row popup-send-sms-counter">
              <span>
                {mensaje.length}/{SMS_MAX_LENGTH} caracteres,{" "}
                <span
                  className={numMensajes > 1 ? "send-sms-multi-warning" : ""}
                >
                  {numMensajes} mensaje{numMensajes > 1 ? "s" : ""}
                </span>
              </span>
            </div>
            <div className="popup-row">
              <div className="label">Móvil</div>
              <InputData
                type="type-phone"
                size={6}
                input={testField}
                onChange={(e) => setTestField(e)}
                customStyle="send-sms-test-input"
              />
              <ButtonIconH
                text="Enviar prueba"
                small={true}
                disabled={
                  mensaje === "" || testField === "" || enviandoPrueba
                }
                onClick={enviarPrueba}
              />
            </div>
            <div className="popup-row-buttons popup-send-sms-buttons">
              <ButtonIconH
                text="Enviar"
                disabled={mensaje === "" || enviando}
                onClick={enviarSMS}
              />
              <ButtonIconH text="Cerrar" onClick={confirmarCierre} />
            </div>
          </div>
        </div>
      </div>
    )
  );
};
